var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-widget"},[_c('i',{staticClass:"circle icon",class:_vm.status.toLowerCase()}),_c('div',[_vm._v(" "+_vm._s(_vm.status)+" "),(_vm.date)?_c('div',{staticClass:"date"},[_vm._v(" "+_vm._s(_vm.date)+" ")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }